<template>
    <div class="ui_card card_eval" :class="{onDelete: isOnDelete}">
        <div class="ui_card_inner">
            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel0')">
                <TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id" @change="checkSelectedEval" :isChecked="isSelected" />
            </div>

            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel1')">
                <div class="candidate_name">
                    <completedMark :evaluation="evaluation" />
                    <div>
                        <router-link :to=" 'evaluations/' + evaluation.id ">
                            <span class="cand_name">{{ evaluation.candidate_username }}</span>
                        </router-link>
                        <div>
                            <span class="cand_name">{{ evaluation.candidate_email }}</span>
                        </div>
                        <div class="associated_recruiter_name" v-if="notOwnedEval">
                            <span>{{ evaluation.recruiter_name }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel2')">
                <div>
                    <div class="add_to_position" v-if="!evaluation.sight_group_id && !notOwnedEval">
                        <AddToPositionModal :evaluation="evaluation" :positionsList="positionsList" :index="index" />
                    </div>
                    <div v-else class="position_name">{{ evaluation.sight_group_name }}</div>
                    <div class="ref_name">{{ getRefName(evaluation.saven_test.sight_ref) }}</div>
                </div>
            </div>

            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel3')">
                <div v-if="evaluation.completed">
                    <div class="reports_dropdown edit_action_button" v-if="!evaluation.in_regen">

                        <ReportsDropDown
                            :doc_files="evaluation.docs_ids"
                            :expert_report_url="evaluation.saven_test.expert_report_url"
                            :passeport_report_url="evaluation.saven_test.passeport_report_url"
                            :customer_report_url="evaluation.saven_test.customer_report_url"
                            @deleteFileClicked="deleteFileFromEval"/>
                    </div>
                    <div class="edit_action_button" v-else>
                        <ReportsInGen/>
                    </div>
                </div>

                <div v-if="!evaluation.completed && !notOwnedEval">
                    <a class="resend_button is-outlined is-info table-button" @click="resendEmail">
                        <IconMail/> {{ $t('modules.evaluations.index.evalsList.resendEvalButton') }}
                    </a>
                </div>
            </div>

            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel4')">{{ createdAt }}</div>

            <div :data-label="$t('modules.evaluations.index.evalsList.tableHeadLabel5')" class="icon_td is-cursor " >
                <TableDeleteButton @confirmClicked="deleteEval" v-if="!notOwnedEval" />
                <div v-else>-</div>
            </div>
        </div>
    </div>
</template>

<script>
import AddToPositionModal from './addToPositionModal'
import ReportsDropDown from './reportsDropDown'
import ReportsInGen from './ReportsInGen'


export default {
    name: 'CardEval',
    props: ['evaluation', 'index'],
    components: {
        AddToPositionModal,
        ReportsDropDown,
        ReportsInGen
    },
    mounted(){
        this.checkReportsRegen()
    },
    data(){
        return {
            isOnDelete: false,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user,
        }
    },
    computed: {
        positionsList(){
            return this.$store.state.PositionStore.positionsList
        },
        createdAt(){
            return this.$date(this.evaluation.created_at, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).fromNow()
        },
        notOwnedEval(){
            return this.userData.id != this.evaluation.user_id
        },
        isSelected(){
            return this.$store.state.EvalStore.selectedEvals.includes(this.evaluation.id)
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        resendEmail(){
            this.$store.dispatch('EvalStore/resendEmail', this.evaluation).then(() => {
                this.$emit('notifSended')
            })
        },
        deleteEval(){
            this.isOnDelete = true
            this.$store.dispatch('EvalStore/deleteEval', this.evaluation).then(() => {
                this.$store.dispatch('EvalStore/indexEvals', {})
                this.$emit('evaluationDeleted')
            })
        },
        ToggleEvalFavorite(isFavorite){
            this.$store.dispatch('EvalStore/saveEval', {id: this.evaluation.id, is_favorite: isFavorite})
        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.evaluation){
                    if (this.evaluation.in_regen){
                        this.$store.dispatch('EvalStore/indexEvals', {})
                    }
                }
            }, 5000)
        },
        deleteFileFromEval(file){
            const evalFiles = JSON.parse(JSON.stringify(this.evaluation.docs_ids))
            this._.remove(evalFiles, function(evalFile){
                return evalFile.file_id == file.file_id
            });
            this.$store.dispatch('EvalStore/saveEval', {id: this.evaluation.id, docs_ids: evalFiles})
        },
        checkSelectedEval(isChecked){
            console.log(isChecked)
            if (isChecked){
                this.$store.dispatch('EvalStore/addEvalToSelection', this.evaluation.id)
            }else{
                this.$store.dispatch('EvalStore/removeEvalFromSelection', this.evaluation.id)
            }

        }

    },
    beforeDestroy () {
        clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss">
.ui_card{
    width: 100%;
    max-width: 400px;
    padding: 12px;
    .ui_card_inner{
        padding: 20px;
        text-align: center;
        border-radius: 10px;
        box-shadow: 2px 2px 6px #b5b5b5;
    }
}
</style>